import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BehavioralPatternImageModule } from '../../core-ui/BehavioralPatternImage/BehavioralPatternImage.module';
import { BehavioralRangesModule } from '../../core-ui/BehavioralRanges/BehavioralRanges.module';
import { CognitiveAssessmentImageModule } from '../../core-ui/CognitiveAssessmentImage/CognitiveAssessmentImage.module';
import { DirectivesModule } from '../../core-ui/Directives/Directives.module';
import { ModalModule } from '../../core-ui/Modal/Modal.module';
import { TooltipModule } from '../../core-ui/Tooltip/Tooltip.module';
import { AssessmentOrJobTargetReminderV2Component } from './AssessmentOrJobTargetReminderV2.component';
import { AssessmentThumbnailComponent } from './AssessmentThumbnail.component';
import { BehavioralIconSVGComponent } from './BehavioralIcon.component';
import { BehavioralThumbnail } from './BehavioralThumb.component';
import { BehavioralThumbnailSVGComponent } from './BehavioralThumbnail.component';
import { CognitiveAssessmentImageThumbnailComponent } from './CognitiveAssessmentImageThumbnail.component';
import { CognitiveIconSVGComponent } from './CognitiveIcon.component';
import { NewTableCognitiveThumbnail } from './NewTableCognitiveThumb.component';

export const BehavioralCognitiveThumbnailsModuleExports = [
    AssessmentOrJobTargetReminderV2Component,
    BehavioralIconSVGComponent,
    BehavioralThumbnail,
    BehavioralThumbnailSVGComponent,
    CognitiveAssessmentImageThumbnailComponent,
    CognitiveIconSVGComponent,
    NewTableCognitiveThumbnail
];

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        TooltipModule,
        BehavioralRangesModule,
        BehavioralPatternImageModule,
        ModalModule,
        RouterModule,
        CognitiveAssessmentImageModule
    ],
    declarations: [
        AssessmentThumbnailComponent,
        ...BehavioralCognitiveThumbnailsModuleExports
    ],
    exports: BehavioralCognitiveThumbnailsModuleExports,
    providers: []
})
export class BehavioralCognitiveThumbnailsModule {}
